import { Colors } from 'cio-design-library/design-tokens'
import styled, { css } from 'styled-components'
import Media from 'builder/styles/media'
import { Content } from '../styles'

export const DividerContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 24px 0px 28px;
`

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: #e1e5e9;
  margin-top: auto;
  margin-bottom: auto;
`

export const OrText = styled.div`
  text-transform: capitalize;
  font-weight: 400;
  font-size: 16px;
  leading-trim: none;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${Colors.Neutral50};
`

export const Wrapper = styled.div`
  margin: auto 0;
  padding: 42px 0 30px;

  ${Media.Phone`
    padding: 32px 0 26px;
  `};
`

export const Footer = styled.div<{ whitelabeled: boolean }>(({ whitelabeled }) => {
  return css`
    display: flex;
    justify-content: space-between;
    margin-top: ${whitelabeled ? '24px' : '0px'};
    font-size: 16px;
    line-height: 20px;
    color: ${Colors.Neutral60};
    text-align: center;
    ${whitelabeled ? 'order: 3;' : ''}

    & a {
      color: ${Colors.Blue50};
    }

    & a:hover {
      color: ${Colors.Blue60};
    }
  `
})

export const WLTitle = styled.div`
  color: ${Colors.Neutral90};
  text-align: center;

  font-family: 'TT Talent';
  font-size: 43px;
  font-style: normal;
  font-weight: 400;
  line-height: 43px; /* 100% */

  margin-bottom: 12px;
`

export const WLSubtitle = styled.div`
  color: ${Colors.Neutral50};
  text-align: center;

  font-family: 'TT Talent';
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 126.316% */
  margin-bottom: 32px;
`

export const SingleSignUpContent = styled(Content)<{ whitelabeled: boolean }>(
  ({ whitelabeled }) => {
    return css`
      ${whitelabeled ? 'flex-direction: column; display: flex;' : ''}
    `
  },
)

// FLEX ORDER FOR WHITELABELED
export const SocialsContainer = styled.div<{ whitelabeled?: boolean }>(({ whitelabeled }) => {
  return css`
    display: flex;
    ${whitelabeled ? 'order: 1; flex-direction: column-reverse;' : ''}
  `
})
